// plugin-registry.ts

import { FmvFeedType } from "../services/wrench-services/fmv-feed.service";

export const PluginClassRegistry: Record<string, any> = {
  FmvFeedType, // key matches factory name in config
  // Add other plugins here
};
